import React, { Fragment, useEffect, useState } from 'react';

import { connect } from 'react-redux';
import { StateModel } from '../redux/store';
import Button from '../components/button/Button';
import InputFieldText from '../components/input/InputFieldText';
import {
  fehlermeldung,
  getTrackAndTraceByAbNrAndEmpfaengerMatchcodeAndPLZ,
  getTrackAndTraceByAbNrAndAbsenderMatchcodeAndPLZ,
  getTrackAndTraceByAbNr,
  getTrackAndTraceByReferenz,
  getTrackAndTraceBySpedeigennr,
  getTrackAndTraceByWebtoken,
  getTrackAndTraceByMandantAndReferenzNr,
} from '../redux/actions/tt';
import { Auftrag, Message, TrackAndTrace } from '../../src/api';
import AuftragInfo from './auftrag/AuftragInfo';
import AuftragHistorie from './auftrag/AuftragHistorie';
import Modal from '../components/modal/Modal';

interface TracktraceProps {
  loading: boolean;
  getTrackAndTraceByWebtoken: (value: string) => void;
  getTrackAndTraceByAbNr: (value: string, plz: string) => void;
  getTrackAndTraceByAbNrAndEmpfaengerMatchcodeAndPLZ: (
    value: string,
    empfmatchcode: string,
    plz: string
  ) => void;
  getTrackAndTraceByAbNrAndAbsenderMatchcodeAndPLZ: (
    value: string,
    absmatchcode: string,
    plz: string
  ) => void;
  getTrackAndTraceByReferenz: (
    bexOrRef: string,
    plz: string,
    datumvon: string | undefined,
    datumbis: string | undefined
  ) => void;
  getTrackAndTraceBySpedeigennr: (bex: string, plz: string) => void;
  getTrackAndTraceByReferenznr: (referenznr: string) => void;
  getTrackAndTraceByMandantAndReferenzNr: (
    mandant: string,
    referenznr: string
  ) => void;
  TT: TrackAndTrace;
  message: Message;
  kunde: string;
  fehlermeldung: (value: string) => void;
}

/**
 * Tracktrace-Component
 *
 * @returns {JSX.Element} Usermanagement-Component
 * @constructor
 */
const Tracktrace = (props: TracktraceProps) => {
  const SPEDEIGENNR_PATH = '/spedeigennr/';
  const REFERENZNR_PATH = '/referenznr/';
  const PLZ_PATH = '/plz/';
  const ABNR_PATH = '/abnr/'; //#85092
  const MANDANT_MATCHCODE_PATH = '/matchcode/'; //#84175
  const EMPFAENGER_MATCHCODE_PATH = '/empfmatchcode/'; //#84175
  const ABSENDER_MATCHCODE_PATH = '/absmatchcode/'; //#84175

  const [query, setQuery] = useState<string>('');
  const [selectedAuftrag, setSelectedAuftrag] = useState<Auftrag>();
  const [showModal, setShowModal] = useState(false);
  const [webtoken, setWebtoken] = useState<string>('');
  const [plz, setPlz] = useState<string>('');
  const [datumVonLocalState, setDatumVonLocalState] = useState<string>();
  const [datumBisLocalState, setDatumBisLocalState] = useState<string>();

  // 'eyJpZGVudGlmaWVyIjoiNDE3MTQyIiwic3ByYWNoZSI6NTB9
  // http://localhost:3001/track-and-trace/?history/eyJpZGVudGlmaWVyIjoiNzAwMDIyMzU2NSIsInBseiI6IjMyMDUyIiwic3ByYWNoZSI6NTB9

  useEffect(() => {
    const search = location.search.replaceAll('%20', ' ');
    const href = location.href.replaceAll('%20', ' ');
    const spedeigennrUrlValue = extractSpedeigennrFromURL(search);
    const plzUrlValue = extractPlzFromURL(search);
    const absmatchcodeUrlValue = extractAbsMatchcodeFromURL(search); //#85092
    let empfmatchcodeUrlValue;
    let abnrUrlValue;
    if (!absmatchcodeUrlValue) {
      empfmatchcodeUrlValue = extractEmpfMatchcodeFromURL(search); //#85092
      abnrUrlValue = extractAbNrFromURL(search); //#85092
    } else {
      abnrUrlValue = extractAbNrBeforeAbsenderMatchcodeFromURL(search); //#85092
    }

    const mandantURLValue = extractMandantFromURL(search); //#84175
    const referenzNrURLValue = extractReferenzNrFromURL(href); //#84175 muss '.href' sein weil Rauten und andere Zeichen vorkommen können. in '.search' wir der pfad dann abgeschnitten
    if (spedeigennrUrlValue && plzUrlValue) {
      props.getTrackAndTraceBySpedeigennr(spedeigennrUrlValue, plzUrlValue);
    } else if (referenzNrURLValue && mandantURLValue) {
      //#84175
      props.getTrackAndTraceByMandantAndReferenzNr(
        mandantURLValue,
        referenzNrURLValue
      );
    }
    //#85092 AbNr
    else if (abnrUrlValue && empfmatchcodeUrlValue && plzUrlValue) {
      props.getTrackAndTraceByAbNrAndEmpfaengerMatchcodeAndPLZ(
        abnrUrlValue,
        empfmatchcodeUrlValue,
        plzUrlValue
      );
    } else if (abnrUrlValue && absmatchcodeUrlValue && plzUrlValue) {
      props.getTrackAndTraceByAbNrAndAbsenderMatchcodeAndPLZ(
        abnrUrlValue,
        absmatchcodeUrlValue,
        plzUrlValue
      );
    } else {
      setWebtoken(location.search.split('/')[1]);
      webtoken && props.getTrackAndTraceByWebtoken(webtoken);
    }
  }, []);

  useEffect(() => {
    webtoken && props.getTrackAndTraceByWebtoken(webtoken);
  }, [webtoken]);

  useEffect(() => {
    setSelectedAuftrag(props.TT.auftrag);
    setQuery(props.TT.auftrag?.spedeigennr ?? ' ');
  }, [props.TT.auftrag]);

  const extractPlzFromURL = (path: string): string => {
    let plz = '';
    if (path.indexOf(PLZ_PATH) !== -1) {
      plz = path.substring(path.indexOf(PLZ_PATH) + PLZ_PATH.length);
    }
    return plz;
  };

  const extractAbNrFromURL = (path: string): string => {
    let abNr = '';
    if (path.indexOf(ABNR_PATH) !== -1) {
      abNr = path.substring(
        path.indexOf(ABNR_PATH) + ABNR_PATH.length,
        path.indexOf(EMPFAENGER_MATCHCODE_PATH)
      );
    }
    return abNr;
  };

  const extractAbNrBeforeAbsenderMatchcodeFromURL = (path: string): string => {
    let abNr = '';
    if (path.indexOf(ABNR_PATH) !== -1) {
      abNr = path.substring(
        path.indexOf(ABNR_PATH) + ABNR_PATH.length,
        path.indexOf(ABSENDER_MATCHCODE_PATH)
      );
    }
    return abNr;
  };

  const extractEmpfMatchcodeFromURL = (path: string): string => {
    let empfaengerMatchcode = '';
    if (path.indexOf(EMPFAENGER_MATCHCODE_PATH) !== -1) {
      empfaengerMatchcode = path.substring(
        path.indexOf(EMPFAENGER_MATCHCODE_PATH) +
          EMPFAENGER_MATCHCODE_PATH.length,
        path.indexOf(PLZ_PATH)
      );
    }
    return empfaengerMatchcode;
  };

  const extractAbsMatchcodeFromURL = (path: string): string => {
    let absenderMatchcode = '';
    if (path.indexOf(ABSENDER_MATCHCODE_PATH) !== -1) {
      absenderMatchcode = path.substring(
        path.indexOf(ABSENDER_MATCHCODE_PATH) + ABSENDER_MATCHCODE_PATH.length,
        path.indexOf(PLZ_PATH)
      );
    }
    return absenderMatchcode;
  };

  const extractSpedeigennrFromURL = (path: string): string => {
    let sped = '';
    if (path.indexOf(SPEDEIGENNR_PATH) !== -1) {
      sped = path.substring(
        path.indexOf(SPEDEIGENNR_PATH) + SPEDEIGENNR_PATH.length,
        path.indexOf(PLZ_PATH)
      );
    }
    return sped;
  };

  const extractMandantFromURL = (path: string): string => {
    //#84175
    let matchcode = '';
    if (path.indexOf(MANDANT_MATCHCODE_PATH) !== -1) {
      matchcode = path.substring(
        path.indexOf(MANDANT_MATCHCODE_PATH) + MANDANT_MATCHCODE_PATH.length,
        path.indexOf(REFERENZNR_PATH)
      );
      return matchcode;
    } else return '';
  };

  const extractReferenzNrFromURL = (path: string): string => {
    //#84175
    let referenzNr = '';
    if (path.indexOf(REFERENZNR_PATH) !== -1) {
      referenzNr = path.substring(
        path.indexOf(REFERENZNR_PATH) + REFERENZNR_PATH.length
      );
    }
    return referenzNr;
  };

  const searchAbNr = (suche: string) => {
    if (suche.length > 0) {
      if (
        props.kunde == 'MMT' ||
        props.kunde == 'WDS' ||
        props.kunde == 'PHL' ||
        props.kunde == 'GERSTLAUER'
      ) {
        props.getTrackAndTraceByAbNr(suche.trim(), plz.trim());
      }
      if (props.kunde == 'BEXITY') {
        props.getTrackAndTraceByReferenz(
          suche.trim(),
          plz.trim(),
          datumVonLocalState,
          datumBisLocalState
        );
      }
    }
  };

  const handleClose = () => {
    setShowModal(false);
    plz && searchAbNr(query);
  };

  const startAnfrage = () => {
    if (datumVonLocalState && datumBisLocalState) {
      if (datumVonLocalState > datumBisLocalState) {
        props.fehlermeldung('Versanddatum bis muss größer sein');
        return;
      }
    }
    setShowModal(true);
  };

  function formatMessageWithLink(message: string) {
    const linkRegex = /(https?:\/\/[^\s]+)/g;
    const parts = message.split(linkRegex);

    return parts.map((part: string, index: number) =>
      linkRegex.test(part) ? (
        <a
          key={index}
          href={part}
          target='_blank'
          rel='noopener noreferrer'
          style={{ color: 'blue', textDecoration: 'underline' }}
        >
          {part}
        </a>
      ) : (
        part
      )
    );
  }

  const lbl =
    props.kunde == 'MMT'
      ? 'Auftragsnummer oder AB-Nr.'
      : props.kunde == 'BEXITY'
      ? 'Bitte Referenznummer oder Bex-Nummer angeben'
      : 'Auftragsnummer, Abs-Referenz';

  // Bei Bexity ist die Suche nach Sendungsnummer nicht eindeutig, da es Aufträge mit derselben Sendungsnummer, aber unterschiedlichen Datums gibt.
  const datumsfelderVisible = props.kunde == 'BEXITY';

  return (
    <div>
      {props.loading ? (
        <div className={'info'}>Daten werden geladen, bitte warten...</div>
      ) : (
        <div className={'tt-wrapper'}>
          <div className={'info'}></div>
          <div className={'search'}>
            <div className={'search-field-wrapper'}>
              <i className='fas fa-search fa-lg' />
              <InputFieldText
                label={lbl}
                name='search'
                classes='search-field'
                onChangeHandler={setQuery}
                maxlength={50}
                value={query}
              />
              {datumsfelderVisible && (
                <Fragment>
                  <InputFieldText
                    label='Versanddatum'
                    classes='datum'
                    inputType='date'
                    onChangeHandler={setDatumVonLocalState}
                    value={datumVonLocalState}
                  />
                  <InputFieldText
                    label='bis '
                    classes='datum'
                    inputType='date'
                    onChangeHandler={setDatumBisLocalState}
                    value={datumBisLocalState}
                  />
                </Fragment>
              )}
            </div>
            <Button
              classes={'abrufen'}
              key={1}
              onClickHandler={() => startAnfrage()}
            >
              Status abrufen
            </Button>
          </div>

          {props.message.message !== undefined &&
          props.TT.auftrag === undefined ? (
            <div className={'error'}>
              <h3>{props.message.header}</h3>
              <p>{formatMessageWithLink(props.message?.message)}</p>
            </div> //TODO:
          ) : (
            <Fragment>
              <div className={'auftrag'}>
                {!!selectedAuftrag && <AuftragInfo auftrag={selectedAuftrag} />}
              </div>
              <div className={'status'}>
                {!!selectedAuftrag &&
                  !!props.TT.defaultstatuskette &&
                  !!props.TT.anzeigeStatus && (
                    <AuftragHistorie
                      auftrag={selectedAuftrag}
                      defaultstatuskette={props.TT.defaultstatuskette}
                      anzeigestatus={props.TT.anzeigeStatus}
                      kunde={props.kunde}
                    />
                  )}
              </div>

              {/*Signatur*/}
              {!!selectedAuftrag?.signatur && (
                <div className={'signatur'}>
                  <div className={'history-content'}>
                    <label className={'info-label'}>
                      {'Signatur Zustellung'}
                    </label>
                    <img
                      src={`data:image/png;base64, ${selectedAuftrag?.signatur}`}
                    />
                  </div>{' '}
                </div>
              )}
            </Fragment>
          )}
          <Modal
            show={showModal}
            closeHandler={handleClose}
            titel={'Sicherheitsabfrage'}
            description={'Bitte geben Sie die Postleitzahl des Empfängers ein'}
            width={'444px'}
            height={'185px'}
            posX={'400px'}
            posY={'300px'}
          >
            <InputFieldText
              label='Empfänger-PLZ '
              name='plz'
              classes='plz-field'
              onChangeHandler={setPlz}
              maxlength={200}
              value={plz}
            />
            <div className={'modal-btn-group'}>
              <button className='modal-btn' onClick={handleClose}>
                Ok
              </button>
            </div>
          </Modal>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state: StateModel) => ({
  loading: state.Loading.loading,
  TT: state.TT,
  message: state.message,
  kunde: state.Config.clientKunde?.toUpperCase() ?? 'WDS',
});

export default connect(mapStateToProps, {
  getTrackAndTraceByWebtoken,
  getTrackAndTraceByAbNrAndEmpfaengerMatchcodeAndPLZ,
  getTrackAndTraceByAbNrAndAbsenderMatchcodeAndPLZ,
  getTrackAndTraceByAbNr,
  getTrackAndTraceByReferenz,
  getTrackAndTraceBySpedeigennr,
  getTrackAndTraceByMandantAndReferenzNr,
  fehlermeldung,
})(Tracktrace);
